import { render, staticRenderFns } from "./UserVerificationRequests.vue?vue&type=template&id=54f0c860&scoped=true&"
import script from "./UserVerificationRequests.vue?vue&type=script&lang=js&"
export * from "./UserVerificationRequests.vue?vue&type=script&lang=js&"
import style0 from "./UserVerificationRequests.vue?vue&type=style&index=0&id=54f0c860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f0c860",
  null
  
)

export default component.exports